<template>
  <div class="search-input-wrapper z-depth-2 white">
    <div class="input-field">
      <input
        type="text"
        :placeholder="
          $store.state.user.langEng ? 'Search for article' : 'Sök efter artikel'
        "
        v-model="inputText"
        autocomplete="off"
        @click:append="performSearch"
        @keyup.enter="performSearch"
        @click:clear="onClearClick"
      />

      <!-- Removed from above to fix the throttling issues where the search text sometimes gets deleted -->
      <!-- @keyup="onKeyUp" -->
      <transition
        :duration="300"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <i v-show="inputText" @click="onClearClick" class="material-icons"
          >close</i
        >
      </transition>
      <transition
        :duration="300"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <i v-show="inputText" @click="performSearch" class="material-icons"
          >search</i
        >
      </transition>
    </div>
  </div>
  <!-- class="search-box" -->
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";

@Component()
export default class SearchArticle extends Vue {
  inputText = this.$store.state.article.searchTerm + "";
  prevInputText = this.inputText;

  @Watch("$store.state.article.searchTerm")
  onSearchTermChange(val) {
    this.inputText = val;
  }

  performSearch() {
    // this.$store.dispatch('forceNewSearch', { searchTerm: 'hejsan', categories: 'lol' })
    this.$store.commit("setSearchTerm", this.inputText);
    let route = this.$route.name;

    // force the user to either home or adminArticles
    if (route != "adminArticles" && route != "home") {
      route = "home";
      this.$store.commit("forceNewSearch", { route });

      // Ugly patch - forceNewSearch resets the search parameter, so set it again! Janis
      this.$store.commit("setSearchTerm", this.inputText);
    }
  }

  onClearClick() {
    setTimeout(() => {
      this.prevInputText = "";
      this.$store.commit("setSearchTerm", "");
    }, 5);
  }

  onKeyUp() {
    if (this.inputText == this.prevInputText) {
      return;
    }
    this.prevInputText = this.inputText;
    // throttle search input to 300ms
    clearTimeout(this.inputThrottler);

    this.inputThrottler = setTimeout(() => {
      this.$store.commit("setSearchTerm", this.inputText);
    }, 300);
  }
}
</script>

<style scoped lang="scss">
.search-input-wrapper {
  border-radius: 5px;
  padding: 0 1em !important;
  margin: 0.25em 0;

  .input-field {
    display: grid;
    grid-template-columns: 1fr 25px 20px;
    align-items: center;
    i {
      user-select: none;
      transition-duration: 200ms;
      &:hover {
        color: gray;
        cursor: pointer;
      }
    }
  }
}
</style>
